// src/services/vendorAuthService.js

import { apiClient } from "./apiClientService";

export const loginVendorService = async (form) => {
  return apiClient("POST", "/api/vendors/login", form);
};

export const googleLoginVendorService = async (googleToken) => {
  return apiClient("POST", "/api/vendors/google-login", {
    token: googleToken,
  });
};
